import { buildProps, definePropType } from '@ll-plus/utils'

import type { ExtractPropTypes } from 'vue'
import type OperateTree from './operate-tree.vue'

export interface IOperateTreeFieldNames {
  children?: string
  title?: string
  key?: string
}

export const operateTreeProps = buildProps({
  /**
   * @description tree-operate操作栏的下拉菜单是否打开(用于如果展开的话，tree-operate不用隐藏)
   */
  operateDropdownOpen: {
    type: Boolean,
    default: false,
  },
  /**
   * @description tree-list的loading
   */
  loading: {
    type: Boolean,
    default: false,
  },
  /**
   * @description 节流时间
   */
  fieldNames: {
    type: definePropType<IOperateTreeFieldNames>(Object),
    default: () => ({ children: 'children', title: 'title', key: 'key' }),
  },
  /**
   * @description tree的数据
   */
  treeData: {
    type: definePropType<any[]>(Array),
  },
  /**
   * @description  tree展开的key
   */
  expandedKeys: {
    type: definePropType<string[] | number[]>(Array),
  },
  dropdownOpenState: {
    type: definePropType<Record<string, boolean>>(Object),
  },
} as const)

export const operateTreeEmits = {
  expand: (expandedKeys: string[], data: any) => expandedKeys || data,
  select: (selectedKeys: string[], e: Event) => selectedKeys || e,
}

// props
export type OperateTreeProps = ExtractPropTypes<typeof operateTreeProps>

// emits
export const OperateTreeEmits = typeof operateTreeEmits

// instance
export type OperateTreeInstance = InstanceType<typeof OperateTree>
